import React from "react";
import { Link } from "react-router-dom";
import PolicyLayout from "./PolicyLayout";
import { formatMoney, SITE_CONFIG } from "../config/siteConfig";

function FAQ() {
  return (
    <PolicyLayout title="Frequently asked questions" intro="Quick answers for the shopping and support paths available on this storefront.">
      <section>
        <h2>What currency and shipping charge are used?</h2>
        <p>Product and checkout amounts are in {SITE_CONFIG.currency}. One {formatMoney(SITE_CONFIG.shippingFee)} shipping charge is added to each checkout and shown separately before payment.</p>
      </section>

      <section>
        <h2>Where can an order be delivered?</h2>
        <p>The available destinations are the countries and regions in the checkout selector. A destination outside {SITE_CONFIG.operatingRegion} follows the <Link to="/international-orders">international orders and customs policy</Link>.</p>
      </section>

      <section>
        <h2>Where are card details entered?</h2>
        <p>Pay Now redirects to Stripe's hosted checkout. Card number, expiry and security code are not fields in the React checkout. The methods displayed by the hosted page are the choices available for that payment session.</p>
      </section>

      <section>
        <h2>Does the payment result page prove settlement?</h2>
        <p>The result page shows how the browser returned from hosted checkout. The associated provider record must confirm payment before fulfilment, cancellation or refund status is decided.</p>
      </section>

      <section>
        <h2>What should I do with a damaged parcel?</h2>
        <p>Stop handling it if glass, leakage, a sharp part or an exposed electrical component creates danger. Keep the parcel label and packing, take photographs, and follow the <Link to="/delivery-issues">delivery problems procedure</Link>.</p>
      </section>

      <section>
        <h2>Can a preference-based return be requested?</h2>
        <p>Request approval before using, washing, attaching, altering, consuming or unnecessarily opening the item. Food, drink and alcohol have seal restrictions; electrical, fragile, textile and accessory goods must satisfy their category condition rules. Read the <Link to="/returns">return, refund and exchange policy</Link> before sending anything.</p>
      </section>

      <section>
        <h2>Why can finish or colour differ?</h2>
        <p>Glaze pooling, brush edges, glass bubbles, wood grain, cotton weave, embroidery and paper fibre vary within the limits described on product pages. Screen and room light also affect colour. A materially wrong product is handled separately from an expected variation.</p>
      </section>

      <section>
        <h2>How are alcohol orders handled?</h2>
        <p>The buyer must complete the age declaration, and lawful receipt may require age evidence. Alcohol is supplied only where the destination and recipient satisfy the applicable sale, import and delivery conditions.</p>
      </section>

      <section>
        <h2>How do I reach support?</h2>
        <p>Email <a href={`mailto:${SITE_CONFIG.supportEmail}`}>{SITE_CONFIG.supportEmail}</a>. Include the order number for a purchase question and never include full card credentials.</p>
      </section>
    </PolicyLayout>
  );
}

export default FAQ;
